import appEvents from 'constants/appEvents.constant';
import appCONST from 'constants/app.constants';

export default function HelpController(
    $scope,
    sessionService,
    userService
) {
    'ngInject';
    const vm = this;
    const questionStates = [];

    Object.assign(vm, {
        toggleQuestion,
        isQuestionOpened,
    });

    function toggleQuestion(index) {
        questionStates[index] = !questionStates[index];
    }

    function isQuestionOpened(index) {
        return !!questionStates[index];
    }

    const KTonlineHelpUrl = 'my-travel/key-travel-academy/';
    const KTFAQUrl = 'my-travel/key-travel-academy/kt-online/';

    function buildParameters(page) {
        return $.param({token: sessionService.getSessionItem('token'), pageUrl: page});
    }

    function updateURLs() {
        $scope.onlineHelpUrl = appCONST.redirectToPageUrl + '?' + buildParameters(KTonlineHelpUrl);
        $scope.FAQUrl = appCONST.redirectToPageUrl + '?' + buildParameters(KTFAQUrl);
    }

    $scope.contactInfo = userService.getRegionalSettings().contactInfo;
    $scope.isUSUser = userService.isUSRegion();
    $scope.isBEUser = userService.isBERegion();

    $scope.$on(appEvents.REFRESH_TOKEN, updateURLs);
    updateURLs();
}



// WEBPACK FOOTER //
// ./src/app/modules/help/help-controller.js